module.exports = __webpack_public_path__ + "static/media/race-right.91b8d90f.jpg";